import { HtmlSerializer } from '@aha-app/aha-editor-v2';
import DOMPurify from 'dompurify';
import markdownit from 'markdown-it';

export function contentToHtml(
  content: string,
  contentType: string | undefined
): string {
  if (!contentType || contentType === 'text/markdown') {
    return markdownit({ breaks: true }).render(content);
  } else {
    return DOMPurify.sanitize(content, {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: [],
      USE_PROFILES: { html: false, svg: false },
    });
  }
}

export function contentToEditorContent(html: string) {
  const serializer = new HtmlSerializer();
  return serializer.deserialize(html).children;
}
